/**
 * L'ingresso, e il cambio della parola d'ordine consegnata.
 *
 * **Il rifiuto e' uno solo.** Il servizio non distingue utenza inesistente da
 * parola sbagliata, e la pagina non deve disfarlo: una frase piu' gentile
 * direbbe a chiunque provi quali identificativi esistono.
 *
 * **La parola consegnata si cambia qui.** Chi ha aperto l'utenza la conosce, e
 * finche' non e' cambiata due persone possono firmare gli stessi verdetti. Il
 * servizio lo impone rifiutando il lavoro (GI-143); senza questa schermata la
 * persona appena creata sbatterebbe contro quel rifiuto senza un modo di
 * uscirne.
 */
import { useState } from 'react'

import { ServiceError } from './api'
import * as auth from './auth'
import { LanguageSwitch } from './carta/LanguageSwitch'
import { LoginCard } from './carta/LoginCard'
import { useT } from './i18n/LocaleProvider'

export interface LoginProps {
  /** Si chiama quando la sessione e' aperta e utilizzabile. */
  onEntered: (session: auth.Session) => void
}

export function Login({ onEntered }: LoginProps): JSX.Element {
  const t = useT()
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [failure, setFailure] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  async function enter(event: React.FormEvent): Promise<void> {
    event.preventDefault()
    setBusy(true)
    setFailure(null)
    try {
      const session = await auth.enter(login, password)
      onEntered(session)
    } catch (error) {
      setFailure(
        error instanceof ServiceError ? error.message : t('login.offline'),
      )
    } finally {
      setBusy(false)
    }
  }

  return (
    <LoginCard title="GridFly" brand>
      <form onSubmit={(event) => void enter(event)}>
        <p>
          <label>
            {t('login.username')}{' '}
            <input
              name="login"
              autoComplete="username"
              value={login}
              onChange={(event) => setLogin(event.target.value)}
            />
          </label>
        </p>
        <p>
          <label>
            {t('login.password')}{' '}
            <input
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
        </p>
        <div className="login-actions">
          <button className="primario" type="submit" disabled={busy || !login || !password}>
            {busy ? t('login.checking') : t('login.enter')}
          </button>
          <LanguageSwitch />
        </div>
      </form>
      {failure !== null && (
        <p role="alert" className="guasto">
          {failure}
        </p>
      )}
    </LoginCard>
  )
}
